import type { CropType, IPhoto, IProject } from '../common/index.js';

export abstract class Designer {

    protected readonly photos: IPhoto[];
    protected readonly project: IProject;
    protected readonly cropStrategy?: CropType;

    public constructor(project: IProject | undefined, photos: IPhoto[] | undefined, cropStrategy?: CropType) {
        if (!project) {
            throw new Error('Project cannot be undefined or null.');
        }

        if (!photos || photos.length === 0) {
            throw new Error('Photos cannot be undefined, null, or empty.');
        }

        this.project = project;
        this.photos = photos;
        this.cropStrategy = cropStrategy;
    }

    public abstract designProject(): IProject;

}
